/**
 * CBD Catalog Effects
 * - 3D tilt on product cards (mouse tracking)
 * - Glow effect following cursor
 * - Scroll-reveal animations (IntersectionObserver)
 */
(function () {
  var MAX_TILT = 8;
  var SCALE = 1.03;
  var TRANSITION = 'transform 0.4s cubic-bezier(0.03,0.98,0.52,0.99), box-shadow 0.4s ease';
  var TRANSITION_OUT = 'transform 0.6s cubic-bezier(0.03,0.98,0.52,0.99), box-shadow 0.6s ease';

  function initCards() {
    var cards = document.querySelectorAll('product-card');
    cards.forEach(function (card) {
      var content = card.querySelector('.product-card__content');
      if (!content) return;
      content.style.willChange = 'transform';
      content.style.transformStyle = 'preserve-3d';

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var cx = rect.width / 2;
        var cy = rect.height / 2;
        var rotX = ((y - cy) / cy) * -MAX_TILT;
        var rotY = ((x - cx) / cx) * MAX_TILT;

        content.style.transition = TRANSITION;
        content.style.transform =
          'perspective(800px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale3d(' + SCALE + ',' + SCALE + ',1)';
        content.style.setProperty('--mouse-x', (x / rect.width * 100) + '%');
        content.style.setProperty('--mouse-y', (y / rect.height * 100) + '%');
      });

      card.addEventListener('mouseleave', function () {
        content.style.transition = TRANSITION_OUT;
        content.style.transform = '';
      });
    });
  }

  /* Scroll reveal with stagger */
  function initReveal() {
    var items = document.querySelectorAll('product-card, .collection-card, .cbd-collection-banner__inner');
    if (!items.length) return;

    var colCount = 1;
    if (items.length > 1) {
      var first = items[0].getBoundingClientRect();
      var second = items[1].getBoundingClientRect();
      if (Math.abs(first.top - second.top) < 5) {
        for (var c = 1; c < items.length; c++) {
          if (Math.abs(items[c].getBoundingClientRect().top - first.top) < 5) {
            colCount = c + 1;
          } else break;
        }
      }
    }

    items.forEach(function (el, i) {
      el.classList.add('cbd-reveal');
      el.style.setProperty('--reveal-delay', ((i % colCount) * 0.08) + 's');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cbd-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* Init on DOM ready + re-init after Shopify section renders */
  function init() {
    initCards();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init after AJAX pagination / section rendering */
  document.addEventListener('shopify:section:load', init);

  /* Handle paginated-list updates */
  var observer = new MutationObserver(function (mutations) {
    var shouldInit = false;
    mutations.forEach(function (m) {
      if (m.addedNodes.length) shouldInit = true;
    });
    if (shouldInit) {
      requestAnimationFrame(function () {
        initCards();
        initReveal();
      });
    }
  });

  var grid = document.querySelector('.product-grid-container, .product-grid');
  if (grid) observer.observe(grid, { childList: true, subtree: true });
})();
